<template>
  <div class="mb-3" :class="finalCustomClass">

    <va-input
      v-if="questionTypes[question.type].inputType !== 'custom' || question.type === 'textarea'"
      v-model="question.answer"
      :id="`question-${question.id}`"
      :label="`${question.text} ${question.required ? '*' : ''}`"
      :type="questionTypes[question.type].inputType"
      :required="question.required"
      :placeholder="questionTypes[question.type].placeholder || '---'"
      :disabled="isInInformationalSection"
      :error="hasError !== false && hasError !== undefined && !isInInformationalSection"
      :error-messages="[hasError]"
    />


    <va-checkbox
      v-else-if="question.type === 'boolean'"
      v-model="question.answer"
      :id="`question-${question.id}`"
      :config="questionTypes[question.type].options"
      :label="`${question.text} ${question.required ? '*' : ''}`"
      :disabled="isInInformationalSection"
    />

    <DatePicker
      v-else-if="['datetime', 'time', 'date'].includes(question.type)"
      v-model="question.answer"
      :id="`question-${question.id}`"
      :label="`${question.text} ${question.required ? '*' : ''}`"
      :config="questionTypes[question.type].options"
      :disabled="isInInformationalSection"
      :error="hasError !== false && hasError !== undefined && !isInInformationalSection"
      :error-messages="[hasError]"
    />
  </div>
</template>
<script>
import DatePicker from '@/components/common/DatePicker'

export default {
  props: {
    section: {
      type: Object,
      required: true
    },
    question: {
      type: Object,
      required: true
    },
    hasError: {
      type: String | Boolean,
      required: false
    },
    customClass: {
      type: String,
      required: false,
      default: 'col-12 col-sm-6'
    }
  },
  components: {
    DatePicker
  },
  data () {
    return {
      timeOptions: {
        dateFormat: 'H:i',
        mode: 'single',
        enableTime: true,
        time_24hr: true,
        minuteIncrement: 1,
        noCalendar: true
      },
      dateOptions: {
        dateFormat: 'Y-m-d',
        mode: 'single',
        enableTime: false
      },
      datetimeOptions: {
        dateFormat: 'Y-m-d H:i:S',
        mode: 'single',
        enableTime: true,
        time_24hr: true,
        minuteIncrement: 1
      },
      questionTypes: {
        boolean: {
          classes: [],
          showClearIcon: false,
          inputType: 'custom'
        },
        time: {
          classes: [],
          showClearIcon: false,
          inputType: 'custom',
          options: {
            dateFormat: 'H:i',
            mode: 'single',
            enableTime: true,
            time_24hr: true,
            minuteIncrement: 1,
            noCalendar: true
          }
        },
        date: {
          classes: [],
          showClearIcon: false,
          inputType: 'custom',
          options: {
            dateFormat: 'Y-m-d',
            mode: 'single',
            enableTime: false
          },
          input: `custom`
        },
        datetime: {
          classes: [],
          showClearIcon: false,
          inputType: 'custom',
          options: {
            dateFormat: 'Y-m-d H:i:S',
            mode: 'single',
            enableTime: true,
            time_24hr: true,
            minuteIncrement: 1
          }
        },
        text: {
          classes: [],
          showClearIcon: false,
          inputType: 'text',
        },
        textarea: {
          classes: [],
          showClearIcon: false,
          inputType: 'textarea',
        },
        numeric: {
          classes: [],
          showClearIcon: false,
          inputType: 'number',
        },
        duration: {
          classes: [],
          showClearIcon: false,
          inputType: 'number',
          placeholder: this.$t('agenda.reports.duration_placeholder')
        }
      }
    }
  },
  methods: {
    getPickerConfigForQuestionType: function (type) {
      return type === 'datetime' ? this.datetimeOptions : type === 'date' ? this.dateOptions : this.timeOptions
    }
  },
  computed: {
    isInInformationalSection: function () {
      return this.section.id === 1
    },
    finalCustomClass: function () {
      return this.question.type !== 'textarea' ? this.customClass : 'col-12'
    }
  },
}
</script>